module.exports = __webpack_public_path__ + "img/full5-min.fb0997b5.png";